// Connects the Archive  record modal action

import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import ArchiveRecord from '../../components/modal/ArchiveRecord';
import { archiveRecords, archiveReceivedRecords } from '../../actions/records';
import { updateUserDetails } from '../../actions/userProfile';

class ArchiveRecordDialog extends Component {
  render() {
    return (
      <div>
        <ArchiveRecord
          {...this.props}
        />
      </div>
    );
  }
}

ArchiveRecordDialog.defaultProps = {
  archiveErrorMessage: '',
};

ArchiveRecordDialog.propTypes = {
  archiveRecords: PropTypes.func.isRequired,
  archiveReceivedRecords: PropTypes.func.isRequired,
  archiveErrorMessage: PropTypes.string,
  updateUserDetails: PropTypes.func.isRequired,
};

export default connect(state => ({
  isLoading: state.records.isLoading,
  archiveErrorMessage: state.records.archiveErrorMessage,
}), { archiveRecords, archiveReceivedRecords, updateUserDetails })(ArchiveRecordDialog);
